import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
// import FoodProperty from '../components/food_property';
import MoreAboutUs from "./more_about_us";
import { pageAction } from '../redux_files/actions/page_actions';
// import { getUserName } from '../utils/common';
// import { checkUserIsAuthAction } from '../redux_files/actions/users_actions';
import BlogsTiles from '../components/blog-tile';
import FoodMenu from '../components/food_menu';

// import { BarCodeScanner } from './barcode_scanner';

const Home = () => {
  const dispatch = useDispatch();
  // const loggedInUserDetails = useSelector(state => state?.usersReducer?.loggedInUserDetails);
  // const userName = getUserName(loggedInUserDetails);
  useEffect(() => {
    document.title = 'Shivay Durga Foods';
    dispatch(pageAction('Shivay Durga Foods'));
  }, [document.title]);
  // useEffect(() => {
  //   if(userName) dispatch(checkUserIsAuthAction());
  // },[]);
  return (
    <>
      <div className='container'>
        {/* <BarCodeScanner /> */}
        {/* <div className='text-center auto-margin'>
          <Link to={userName ? '/cart' : '/login'}><div className='primary-button'>Order Now</div></Link>
        </div> */}
        <div className='text-center mt-20'>
          <Link to='/our-food-menu'><div className='primary-button'>Our Daily Menu</div></Link>
        </div>
        <BlogsTiles />
        <FoodMenu />
        <MoreAboutUs />
        {/* <FoodProperty /> */}
      
    </div>
     </>
  );
};

export default Home;
